<template>
  <div class="massBalanceDevicesWrapper">
    <CurrentBillingSummary
      notManagement
    />
  </div>
</template>

<script>
import CurrentBillingSummary from '@/views/admin/aquassistBilling/billingRegisterComponent/CurrentBillingSummary.vue';

export default {
    name: 'BillingRegister',
    components: {
        CurrentBillingSummary,
    },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
</style>
